module.exports = __webpack_public_path__ + "static/media/zephyr.bf38995f.png";